import { ROLE } from "app/common/roleConstant";
import { isObject } from "lodash";

export function getLoggedUserAccountId() {
  return getLoggedUserAccountId2();
}

/**
 * to check user has Multiple Account and any one is not selected
 * @returns boolean
 */
export function hasMultipleAccounts() {
  const storageData = localStorage.getItem('yoke:permissions');
  const block = storageData && storageData.length ? JSON.parse(storageData) : null;
  const accountIds = block?.permissions?.map(b => b.accountId).filter((v, i, a) => a.indexOf(v) === i) || [];
  const operator = new URLSearchParams(window.location.search).get('operator');
  const isDefaultOperator = String(operator) === '1';
  return  (getScope() === ROLE.SUPERADMIN) ? isDefaultOperator : (accountIds.length > 1 && isDefaultOperator)
  
}

/**
 * to check user has Multiple Accounts
 * @returns boolean
 */
export function hasMultipleAccounts2() {
  const storageData = localStorage.getItem('yoke:permissions');
  const block = storageData && storageData.length ? JSON.parse(storageData) : null;
  const accountIds = block?.permissions?.map(b => b.accountId).filter((v, i, a) => a.indexOf(v) === i) || [];
  const operator = new URLSearchParams(window.location.search).get('operator');
  return (getScope() === ROLE.SUPERADMIN) ? true : (accountIds.length > 1 && String(operator) === '1')
}

export function getLoggedUserAccountId2() {
  const storageData = localStorage.getItem('yoke:permissions');
  const block = storageData && storageData.length ? JSON.parse(storageData) : null;
  const operator = new URLSearchParams(window.location.search).get('operator');
  const id = String(operator) === '1' ? block?.permissions?.[0] : operator
  /**
   * @description
   * checking if id is an object
   * if object then we are passing as id.accountId
   * else id
   * */ 
  if(id){
    return !isObject(id) ? id : id?.accountId;
  }
}

export function getScope() {
  const storageData = localStorage.getItem('yoke:scope')

  return storageData;
}

/*
* Get the permissions set for this user at this operator, or the operator selected
*/
export function getPermissionBlocksForAccount() {
  const storageData = localStorage.getItem('yoke:permissions')
  if (storageData === null)
    return null
  const jsonBlocks = JSON.parse(storageData)
  const selectedAccountId = getLoggedUserAccountId2();
  const permissionBlock = jsonBlocks.permissions?.filter(b => String(b.accountId) === String(selectedAccountId))[0]
  if (permissionBlock !== null && permissionBlock !== undefined)
    return permissionBlock;
  else 
    return false
}
